<template>
  <div class="content">
    <!-- start of search -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div ">模板名称</div>
          <el-input size="small" v-model="page.templateName" class="w65f" placeholder="请输入" :clearable="true"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div ">应用端</div>
          <el-select size="small" @change="changeClassification" v-model="page.appSideGuids" placeholder="请选择"
            class="w65f" filterable clearable>
            <el-option v-for="item in applicationSideList" :key="item.guid" :label="item.appSideName"
              :value="item.guid"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="t-left">
          <el-button size="small" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="small" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- end of search -->

    <!-- start of button -->
    <div class="button-area">
      <el-button icon="el-icon-plus" size="small" type="info" @click="addData">添加消息模板</el-button>
    </div>
    <!-- start of button -->

    <!-- start of table -->
    <div class="back-color-fff" style="padding: 16px">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <!-- 模板编号 -->
        <el-table-column label="模板编号" prop="templateCode" width="150" header-align="center" align="right"
          show-overflow-tooltip></el-table-column>
        <!-- 模板名称 -->
        <el-table-column prop="templateName" label="模板名称" header-align="center" align="left"
          show-overflow-tooltip></el-table-column>
        <!-- 应用端 -->
        <el-table-column prop="appSideGuids" label="应用端" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-for="item in JSON.parse(scope.row.appSideGuids)">
              {{ item.appSideName }} &nbsp;
            </span>
          </template>
        </el-table-column>
        <!-- 消息类型 -->
        <el-table-column prop="messageType" label="消息类型" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-for="item in scope.row.messageType.split(',')">
              {{ messageTypeObj[item] }} &nbsp;
            </span>
          </template>
        </el-table-column>
        <!-- 排序 -->
        <el-table-column prop="orderNum" label="排序" width="90" header-align="center" align="center"
          show-overflow-tooltip></el-table-column>
        <!-- 启用状态 -->
        <el-table-column prop="isEnable" label="启用状态" header-align="center" align="left" width="90">
          <template slot-scope="scope">{{ scope.row.isEnable == 'Y' ? '启用' : '停用' }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="180">
          <template slot-scope="scope">
            <a class="txt-color" @click="changeStatus(scope.row)">{{ scope.row.isEnable == 'Y' ? '停用' : '启用' }} | </a>
            <a class="txt-color" @click="copyData(scope.row)">复制 | </a>
            <a class="txt-color" @click="editData(scope.row)">编辑 | </a>
            <a class="txt-color" @click="delData(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- end of table -->

    <!-- start of pagination -->
    <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 30, 50]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <!-- end of pagination -->

    <!-- start of dialog-add|edit|copy -->
    <el-dialog :title="editTitle" :visible.sync="dialogEdit" width="70%">
      <el-form :model="formData" :rules="formRules" ref="formData" label-width="150px" :label-position="'right'">
        <!-- 模板分类 -->
        <el-form-item label="模板分类" prop="templateCategoryGuid">
          <div class="classification-box">
            <el-select size="small" @change="changeClassification" v-model="formData.templateCategoryGuid"
              placeholder="请选择" class="c1" filterable clearable>
              <el-option v-for="item in classificationList" :key="item.guid" :label="item.text"
                :value="item.guid"></el-option>
            </el-select>
            <el-input size="small" class="c2" placeholder="分类名称" clearable v-model="tempCategoryData.dicName"
              autocomplete="off"></el-input>
            <el-input size="small" class="c3" type="text" placeholder="界面排序"
              oninput="value=value.replace(/[^\Z0-9]/g, '')" clearable v-model="tempCategoryData.orderNum"
              autocomplete="off"></el-input>
            <el-button size="small" type="info" @click="editTempCategory">
              {{ formData.templateCategoryGuid ? '修改' : '添加' }}
            </el-button>
          </div>
        </el-form-item>
        <!-- 模板编号 -->
        <el-form-item label="模板编号" prop="templateCode">
          <el-input size="small" :maxlength="25" oninput="value=value.replace(/[^\a-\z\A-\Z0-9]/g, '')" clearable
            v-model="formData.templateCode" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <!-- 模板名称 -->
        <el-form-item label="模板名称" prop="templateName">
          <el-input size="small" :maxlength="25" v-model="formData.templateName" clearable autocomplete="off"
            class="w100f"></el-input>
        </el-form-item>
        <!-- 消息类型 -->
        <el-form-item label="消息类型" prop="messageType">
          <el-checkbox-group size="small" v-model="formData.messageType" class="t-left">
            <el-checkbox v-for="item in messageTypeList" :label="item.value" :key="item.value">
              {{ item.text }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 应用端 -->
        <el-form-item label="应用端" prop="appSideGuids"
          v-if="formData.messageType.indexOf('1') > -1 || formData.messageType.indexOf('2') > -1" :rules="[{
            required: true, message: '应用端必填', trigger: 'blur'
          }]">
          <el-checkbox-group size="small" v-model="formData.appSideGuids" class="t-left" @change="changeAppSide">
            <el-checkbox v-for="(item) in applicationSideList" :label="item.guid" :key="item.guid" >
              {{ item.appSideName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- PC端跳转链接 -->
        <el-form-item label="PC端跳转链接" prop="pcJumpUrl" v-if="showPc" :rules="[{
          required: true, message: 'PC端跳转链接必填', trigger: 'blur'
        }]">
          <el-input size="small" v-model="formData.pcJumpUrl" autocomplete="off" class="w100f" type="textarea"></el-input>
        </el-form-item>
        <!-- 移动端跳转链接 -->
        <el-form-item label="移动端跳转链接" prop="appJumpUrl" v-if="formData.messageType.indexOf('3') > -1 || showApp" :rules="[{
          required: true, message: '移动端跳转链接内容必填', trigger: 'blur'
        }]">
          <el-input size="small" v-model="formData.appJumpUrl" autocomplete="off" class="w100f"
            type="textarea"></el-input>
        </el-form-item>
        <!-- 待办/消息通知内容 -->
        <el-form-item label="待办/消息通知内容" prop="messageContent"
          v-if="formData.messageType.indexOf('1') > -1 || formData.messageType.indexOf('2') > -1" :rules="[{
            required: true, message: '待办/消息通知内容必填', trigger: 'blur'
          }]">
          <el-input size="small" oninput="if(value.length>100)value=value.slice(0, 100)" v-model="formData.messageContent"
            autocomplete="off" class="w100f" type="textarea"></el-input>
        </el-form-item>
        <!-- 短信内容 -->
        <el-form-item label="短信内容" prop="smsContent" v-if="formData.messageType.indexOf('4') > -1" :rules="[{
          required: true, message: '短信内容必填', trigger: 'blur'
        }]">
          <el-input size="small" oninput="if(value.length>100)value=value.slice(0, 100)" v-model="formData.smsContent"
            autocomplete="off" class="w100f" type="textarea"></el-input>
        </el-form-item>
        <!-- 微信消息类型 -->
        <el-form-item label="微信消息类型" prop="wechatType" v-if="formData.messageType.indexOf('3') > -1" :rules="[{
          required: true, message: '微信消息类型', trigger: 'blur'
        }]">
        <el-select size="small" style="width:100%"  v-model="formData.wechatType" placeholder="请选择"  filterable clearable>
            <el-option v-for="item in  getCodeListByKey('微信消息模版')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
        </el-form-item>
        <!-- 微信模板ID -->
        <el-form-item label="微信模板ID" prop="wechatTemplateId" v-if="formData.messageType.indexOf('3') > -1" :rules="[{
          required: true, message: '微信模板ID必填', trigger: 'blur'
        }]">
          <el-input size="small" oninput="if(value.length>60)value=value.slice(0, 60)" v-model="formData.wechatTemplateId"
            autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <!-- 产品中心 -->
        <!-- <el-form-item label="产品应用中心" prop="productGuid">
          <el-select size="small" v-model="formData.productGuid" placeholder="请选择" class="w100f" filterable>
            <el-option v-for="item in productList" :key="item.guid" :label="item.productName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- 产品中心 -->
        <!-- <el-form-item label="运营端应用产品" prop="productGuid" v-if="showPro" :rules="[{ required: true, message: '运营端应用产品必填', trigger: 'change' }]">
          <el-select size="small" v-model="formData.productGuid" placeholder="请选择" class="w100f" filterable>
            <el-option v-for="item in productList" :key="item.guid" :label="item.productName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- 产品中心 -->
        <!-- <el-form-item label="企业端应用产品" prop="tenantProductGuid" v-if="showTen" :rules="[{ required: true, message: '企业端应用产品必填', trigger: 'change' }]">
          <el-select size="small" v-model="formData.tenantProductGuid" placeholder="请选择" class="w100f" filterable>
            <el-option v-for="item in tenantProductList" :key="item.guid" :label="item.productName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- 通知角色 -->
        <el-form-item label="通知角色" prop="roleGuids">
          <el-cascader placeholder="请选择" class="w100f" ref="cascaderAddr" v-model="formData.roleGuids" collapse-tags
            :props="{ multiple: true }" :options="roleList" clearable filterable></el-cascader>
        </el-form-item>
        <!-- 消息单位 -->
        <el-form-item label="消息单位" prop="messageUnit">
          <el-input size="small" :maxlength="5" v-model="formData.messageUnit" autocomplete="off"
            class="w100f"></el-input>
        </el-form-item>
        <!-- 界面排序 -->
        <el-form-item label="界面排序" prop="orderNum" v-if="editTitle == '编辑消息模板'" :rules="[
          { required: true, message: '界面排序必填', trigger: 'blur' },
        ]">
          <el-input v-model="formData.orderNum" :maxlength="8" onkeyup="this.value = this.value.replace(/\D/g, '')"
            autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <!-- 是否定期 -->
        <el-form-item label="是否定期" prop="isTiming" class="timeRadio" :rules="[{ required: true, message: '是否定期必填', trigger: 'change' }]">
          
          
          <el-radio-group v-model="formData.isTiming" @input="changeTime">
            <el-radio  label="Y">是</el-radio>
            <el-radio  label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 执行周期 -->
        <el-form-item label="执行周期" prop="cron" ref='time' class="display-inblock">
          <span v-if="formData.isTiming=='Y'" slot="label" style="color: #F56C6C">* </span>
          <span slot="label">执行周期 </span>
          <el-popover v-model="showTime"  placement="bottom" width="520" @hide="changePeriod">
            <timePeriod ref="timePeriod" :visible.sync="showTime" :value="cron" @input="changeSyncPeriod" ></timePeriod>
            <el-input slot="reference" v-model="formData.cron" placeholder="请输入"></el-input>
            
          </el-popover>
          <!-- <el-popover v-model="periodExecuteTiemeVisible" class="display-inblock" placement="bottom" width="160" popper-class="el-popover-minw90">
              <div class="mt16 t-center">接下来五次执行时间:</div>
              <div v-for="(item, index) in executeTiemes" :key="index" class="check-item t-center">
                {{ item }}
              </div>
              <el-button slot="reference" size="small" class="ml5" type="info" @click="getExecuteTimes()">执行计划</el-button>
            </el-popover> -->
          

        </el-form-item>
        <div class="border1px" v-if="formData.cron">
          <p>说明：{{ finalTitle }}</p>
        </div>
        <!-- 消息图标 -->
        <el-form-item label="消息图标" prop="iconUrl">
          <el-dialog :visible.sync="dialogVisible" :modal="false">
            <img width="100%" :src="formData.iconUrl" alt="" />
          </el-dialog>
          <el-upload action="#" name="image" class="fl ml10" list-type="picture-card" :headers="token"
            :file-list="fileList" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
            :http-request="uploadImage">
            <div slot="image" slot-scope="{ file }">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="small" @click="dialogEdit = false">取消</el-button>
        <el-button size="small" type="info" @click="submitFormData()">确定</el-button>
      </div>
    </el-dialog>
    <!-- end of dialog-add|edit|copy -->
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import timePeriod from '@/components/timePeriod/timePeriod'
import {transferCronexPressionToText} from '@/filter/txt'
export default {
 components:{
  timePeriod
 },
  data() {
    return {
      wechatTypeOp:[
        {
          value:'1',
          text:'流程驳回消息'
        },
        {
          value:'2',
          text:'流程通过消息'
        },
        {
          value:'3',
          text:'申请审核消息'
        },
        {
          value:'4',
          text:'业务员工作消息'
        },
        {
          value:'5',
          text:'内部工作消息'
        },
        {
          value:'6',
          text:'考核确认消息'
        }
      ],
      editTitle: '添加消息模板',
      dialogEdit: false, // 新增编辑弹框是否展示
      showTime:false,//执行周期
      periodExecuteTiemeVisible:false,
      cron:'',
      finalTitle:'',
      executeTiemes:[],
      // 新增修改表单字段
      formData: {
        templateCategoryGuid: null, // 模板分类
        templateCode: '', // 模板编号
        templateName: '', // 模板名称
        messageType: [], // 消息类型
        appSideGuids: [], // 应用端
        appSideItems:[],//index组成的数组
        pcJumpUrl: '', // pc端跳转链接
        appJumpUrl: '', // 移动端跳转链接
        messageContent: '', // 待办消息通知内容
        smsContent: '', // 短信内容
        wechatTemplateId: '', // 微信消息类型
        wechatType: '', // 微信模板ID
        roleGuids: [], // 通知角色id
        messageUnit: '条', // 消息单位
        orderNum: '', // 界面排序
        isTiming: '', // 是否定期
        cron: '', // 执行周期
        iconUrl: '', // 消息图标
        // productGuid: null,//运营端应用产品
        // tenantProductGuid:null// 企业端应用产品
      },
      // 新增修改表单字段验证规则
      formRules: {
        templateCategoryGuid: [
          { required: true, message: '模板分类必填', trigger: 'change' },
        ],
        templateCode: [
          { required: true, message: '模板编号必填', trigger: 'blur' },
        ],
        templateName: [
          { required: true, message: '模板名称必填', trigger: 'blur' },
        ],
        appSideGuids: [
          { required: true, message: '应用端必填', trigger: 'blur' },
        ],
        messageType: [
          { required: true, message: '消息类型必填', trigger: 'change' },
        ],
        // productGuid: [
        //   { required: true, message: '产品应用中心必填', trigger: 'change' },
        // ]
        
      },
      // 模板分类下拉选
      classificationList: [{
        guid: '',
        text: '无可选分类'
      }],
      tempCategoryData: {
        "dicName": '',
        "dicValue": '',
        "orderNum": '',
        "parentGuid": '', // 消息模版分类字典guid
        "parentName": '消息模版分类字典', // 消息模版分类字典名称
      },
      messageTypeObj: {
        1: '待办',
        2: '消息',
        3: '微信',
        4: '短信',
      },
      // 消息类型下拉选
      messageTypeList: [
        {
          text: '待办',
          value: '1'
        }, {
          text: '消息',
          value: '2'
        }, {
          text: '微信',
          value: '3'
        }, {
          text: '短信',
          value: '4'
        }
      ],
      // 应用端下拉选
      applicationSideList: [],
      // 角色下拉选
      roleList: [],

      url: `${route}/ms-common-admin-cloud-service/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      dialogVisible: false,
      dialogImageUrl1: '',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        templateName: '', // 模板名称 
        appSideGuids: '', // 应用端
      },
      productList:[],
      tenantProductList:[],
      tableData: [],
      fileList: [],
      loading: false,

      operationGuid: '', // 运营端guid
      superTenantsGuid: '', // 超级运营公司得tenantGuid

      showApp: false,
      showPc: false,
      showPro:false,
      showTen:false,
    };
  },
  created() {
    // 列表
    this.getData(false);
    // 获取模板分类下拉选数据
    this.getClassificationData();
    // 超级运营公司的tenantGuid
    this.getTenants();
    // let that = this;
    // Promise.all(that.getAppSideGuidList(), that.getAppSideGuidList()).then(() => {
    //   that.getRoleData()
    // }).catch(error => {
    //   console.log(error)
    // })
  },
  methods: {
    getExecuteTimes(){
      console.log('1010');
      
    },
    changeTime(val){
      console.log('vvv',val);
      if(val=="Y"){
        this.formRules.cron=[{ required: true, message: '执行周期必填', trigger: 'change' }]
        console.log('11',this.formRules);
        // this.$refs['formData'].resetFields();
        // this.$refs.formData.validateField('cron');
      }else if(val=="N"){
        this.formRules.cron=null
        // this.$refs.formData.resetFields();
        this.$refs.formData.clearValidate("cron");
      }
    },
    // 执行周期
    changeSyncPeriod(val,txt){
    
      if(!val)return 
      this.cron=val
      console.log('txt',txt,this.cron);
      // if(txt.length<1){
      //   txt=transferCronexPressionToText(this.cron,false)
      // }
      
      this.finalTitle=txt.join("，")
      console.log('finalTitle',this.finalTitle);
      
    },
    // 获取执行计划
    getExecuteTimes(){

    },
    
    changePeriod(){
      this.formData.cron=this.cron
    },
    // 获取应用端数据
    getAppSideGuidList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
      };
      self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/appside/data/get`, query).then((res) => {
        if (res.data.code == '00000') {
          this.applicationSideList = res.data.data.records || [];
          // 拿到运营端guid
          let appSideArr = res.data.data.records.filter(item => item.appSideName == '运营端');
          if (appSideArr.length > 0) {
            this.operationGuid = appSideArr[0]['guid'];

            // 获取角色
            this.getRoleData()
          }

        }
      });
    },
    //获取产品
    getAllProduct(id,type) {
      let self = this;
      if(!self.formData.appSideGuids){
        self.$message.error('请先选择应用端');
        return
      }
      
      // let query = {
      //   pageIndex: 1,
      //   pageSize: -1,
      //   appSideGuidList: self.formData.appSideGuids,
      //   platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
      // }
      if(type){
        let query = {
          pageIndex: 1,
          pageSize: -1,
          appSideGuidList: [id],
          platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
        }
        self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/product/data/get`, query).then((res) => {
        if (res.data.code == '00000') {
          if (res.data.data && res.data.data.records ) {
            type==1?self.productList = res.data.data.records:self.tenantProductList = res.data.data.records
            
          } else {
            self.productList = [];
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
      }
      // self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/product/data/get`, query).then((res) => {
      //   if (res.data.code == '00000') {
      //     if (res.data.data && res.data.data.records ) {
      //       self.productList = res.data.data.records;
      //     } else {
      //       self.productList = [];
      //     }
      //   } else {
      //     self.$message.error(res.data.msg);
      //   }
      // });
    },
    /**
     * 获取模板分类下拉选数据
     */
    getClassificationData() {
      let that = this;
      that.api.get(
        `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=消息模版分类字典`,
      ).then((resp) => {
        const { data } = resp;
        if (data.code == '00000') {
          let datas = data.data || [];
          // console.log(datas)
          // 给模板分类下拉选赋值
          datas.push({
            guid: '',
            text: '无可选分类'
          })
          this.classificationList = datas;
        }
      });
    },
    changeAppSide(val) {
      console.log('val',val)
      console.log('applicationSideList',this.applicationSideList)
      this.showApp = false;
      this.showPc = false;
      this.showPro = false;
      this.showTen = false;
      val.forEach(item => {
        this.applicationSideList.forEach(citem => {
          if (item == citem.guid) {
            if (citem.appSideName == '移动端' || citem.appSideName == '微信') {
              this.showApp = true;
            } else {
              this.showPc = true;
            }
            if (citem.appSideName == '运营端' ) {
              this.showPro = true;
              this.getAllProduct(citem.guid,1)
            } else if (citem.appSideName == '企业端' ) {
              this.showTen = true;
              this.getAllProduct(citem.guid,2)
            }
            
          }
        })
      })
     
    },
    
    /**
     * 根据条件获取企业
     */
    getTenants() {
      let that = this;
      that.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        {
          pageIndex: 1,
          pageSize: -1,
          supertubeFlag: 'Y', // 超管标识(Y 是；N：否)
          enterpriseCate: '9901', // 9901 运营公司；9902 劳务公司；9903 代缴公司；9904 代征公司
        }
      ).then((res) => {
        if (res.data.code == '00000') {
          // console.log(res.data)
          // 获取超级运营公司的guid
          if (res.data.data.records && res.data.data.records.length > 0) {
            this.superTenantsGuid = res.data.data.records[0]['guid'];

            // 获取应用端数据
            this.getAppSideGuidList();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    /**
     * 获取角色下拉选数据
     */
    getRoleData() {
      let that = this;
      that.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/get-all-role-list`).then((res) => {
        if (res.data.code == '00000') {
          let roleList = res.data.data;
          roleList.forEach(item => {
            item.value = item.tenantGuid;
            item.label = item.tenantName;
            if (item.roleList) {
              item.roleList.forEach(j => {
                j.label = j.roleName
                j.value = j.guid;
              })
              item.children = item.roleList;
            }

          })
          console.log(roleList)
          this.roleList = roleList;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 新增或者修改模板分类
     */
    editTempCategory() {
      if (!this.tempCategoryData['dicName']) {
        return this.$message.error('分类名称不能为空')
      }
      if (!this.tempCategoryData['orderNum']) {
        return this.$message.error('排序不能为空')
      }
      this.tempCategoryData['dicValue'] = this.tempCategoryData['dicName'];
      this.api.postJson(
        `/${serverConfig.msConfigureService}/dict/save-dict`,
        this.tempCategoryData
      ).then((res) => {
        if (res.data.code == '00000') {
          this.getClassificationData();// 重新获取模板分类下拉选
          this.tempCategoryData = {
            "dicName": '',
            "dicValue": '',
            "orderNum": '',
            "parentGuid": '', // 消息模版分类字典guid
            "parentName": '消息模版分类字典', // 消息模版分类字典名称
          }
          this.$message.success('保存成功');
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 新增
     */
    addData() {
      // 新增前将表单的数据全部清空
      this.formData = {
        templateCategoryGuid: null, // 模板分类
        templateCode: '', // 模板编号
        templateName: '', // 模板名称
        messageType: [], // 消息类型
        appSideGuids: [], // 应用端
        pcJumpUrl: '', // pc端跳转链接
        appJumpUrl: '', // 移动端跳转链接
        messageContent: '', // 待办消息通知内容
        smsContent: '', // 短信内容
        wechatTemplateId: '', // 微信模板ID
        roleGuids: null, // 通知角色id
        messageUnit: '条', // 消息单位
        orderNum: '', // 界面排序
        iconUrl: '', // 消息图标
        // productGuid: null,// 运营端应用产品
        // tenantProductGuid:null// 企业端应用产品
        
      };
      this.fileList = []

      this.tempCategoryData = {
        "dicName": '',
        "dicValue": '',
        "orderNum": '',
        "parentGuid": '', // 消息模版分类字典guid
        "parentName": '消息模版分类字典', // 消息模版分类字典名称
      };
      this.dialogEdit = true;
      this.editTitle = '添加消息模板';
      this.$nextTick(() => {
        this.$refs['formData'].clearValidate();
      })
    },
    /**
     * 编辑
     * @param {*} row 
     */
    editData(row) {
      // console.log(row,111)
      this.formData = JSON.parse(JSON.stringify(row));
      // 执行周期
      this.cron=this.formData.cron||""
      
      
      let txt=transferCronexPressionToText(this.cron,false)
      console.log('txt',txt);
      if(txt){
        this.finalTitle=txt.join("，")
      }
      
      
      
      console.log('finalTitle',this.finalTitle);
      
      // 应用端数据处理
      let appSideGuids = JSON.parse(row.appSideGuids) || [];
      let arr = [];
      appSideGuids.forEach(item => {
        arr.push(item.appSideGuid)
      })
      this.formData['appSideGuids'] = arr;
      this.changeAppSide(arr);
      if (row.messageType) {
        this.formData.messageType = row.messageType.split(',');
      }
      // 角色数据处理
      let roleGuids = JSON.parse(row.roleGuids) || [];
      let roleArr = [];
      roleGuids.forEach(item => {
        roleArr.push([item.tenantGuid, item.guid])
      })
      this.formData['roleGuids'] = roleArr;
      // 消息图标数据处理
      this.fileList = []
      if (row.iconUrl) {
        let item = {
          name: 'icon',
          url: row.iconUrl
        }
        this.fileList.push(item);
        this.formData['iconUrl'] = row.iconUrl
      }
      
      
      this.dialogEdit = true;
      this.editTitle = '编辑消息模板';
      
      
      this.$forceUpdate();
      this.getAllProduct();
      // this.$nextTick(() => {
      //   this.$refs['formData'].clearValidate();
      // })
    },
    /**
     * 复制
     * @param {*} row 
     */
    copyData(row) {
      // console.log(row)
      this.formData = JSON.parse(JSON.stringify(row));
      // 应用端数据处理
      let appSideGuids = JSON.parse(row.appSideGuids) || [];
      let arr = [];
      appSideGuids.forEach(item => {
        arr.push(item.appSideGuid)
      })
      this.formData['appSideGuids'] = arr;

      if (row.messageType) {
        this.formData.messageType = row.messageType.split(',');
      }

      // 角色数据处理
      // 角色数据处理
      let roleGuids = JSON.parse(row.roleGuids) || [];
      let roleArr = [];
      roleGuids.forEach(item => {
        roleArr.push([item.tenantGuid, item.guid])
      })
      this.formData['roleGuids'] = roleArr;
      // 消息图标数据处理
      this.fileList = []
      if (row.iconUrl) {
        let item = {
          name: 'icon',
          url: row.iconUrl
        }
        this.fileList.push(item);
        this.formData['iconUrl'] = row.iconUrl
      }
      this.dialogEdit = true;
      this.editTitle = '复制消息模板';
      // this.$refs['formData'].clearValidate();
    },
    /**
     * 删除
     * @param {*} guid 
     */
    delData(guid) {
      let that = this;
      that.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        that.api
          .postJson('/ms-configure-service/message/template/delete-message-template?guid=' + guid)
          .then((res) => {
            if (res.data.code == '00000') {
              that.$message.success('删除成功');
              that.getData(true);
            } else {
              that.$message.error(res.data.msg);
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
    /**
     * 修改启用 停用状态
     * @param {*} row 
     */
    changeStatus(row) {
      var postData = row;
      let editUrl = '/message/template/update-message-template'; // 修改
      if (row.isEnable == "Y") {
        let that = this;
        this.$confirm('停用后，将不会发送此消息，确定操作吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          postData['isEnable'] = "N"
          that.postData(editUrl, postData, '停用成功')

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });

      } else if (row.isEnable == "N") {
        postData['isEnable'] = "Y"
        this.postData(editUrl, postData, '启用成功')
      }
    },
    /**
     * 选择模板分类
     */
    changeClassification(val) {
      // console.log(val)
      if (!val) {
        return this.tempCategoryData = {
          "dicName": '',
          "dicValue": '',
          "orderNum": '',
          "parentGuid": '', // 消息模版分类字典guid
          "parentName": '消息模版分类字典', // 消息模版分类字典名称
        }
      }
      let list = this.classificationList || [];
      list.forEach(item => {
        if (item.guid) {
          if (item.guid == val) {
            this.tempCategoryData['dicName'] = item.text;
            this.tempCategoryData['dicValue'] = item.text;
            this.tempCategoryData['guid'] = item.guid;
            this.tempCategoryData['orderNum'] = item.orderNum;
          }
        }
      })
    },
    /**
     * 提交表单
     */
    submitFormData() {
      let that = this;
      let addUrl = '/message/template/add-message-template'; // 新增
      let editUrl = '/message/template/update-message-template'; // 修改

      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.formData.messageType = this.formData.messageType.toString();
          //处理角色
          let roleArr = [];
          let cascaderAddr = this.$refs.cascaderAddr;
          try {
            cascaderAddr.checkedNodes.forEach(item => {
              if (!item.parent) {
                throw new Error('请选择正确的角色');
              }
              roleArr.push({
                roleName: item.label,
                guid: item.value,
                tenantGuid: item.parent.value
              })
            })

          } catch (e) {
            this.$message.error(e.message);
            return;
          }
          // 处理应用端数据格式
          let appSideGuids = JSON.parse(JSON.stringify(this.formData.appSideGuids || []));
          let applicationSideList = JSON.parse(JSON.stringify(this.applicationSideList || []));
          let arr = [];
          appSideGuids.forEach(item => {
            applicationSideList.forEach(citem => {
              if (item == citem.guid) {
                arr.push({
                  appSideName: citem.appSideName,
                  appSideGuid: item
                })
              }
            })
          })
          this.formData.appSideGuids = JSON.stringify(arr);
          this.formData.roleGuids = JSON.stringify(roleArr);
          

          if (that.editTitle == '添加消息模板') {
            that.postData(addUrl, that.formData)
            return;
          }
          if (that.editTitle == '编辑消息模板') {
            that.postData(editUrl, that.formData)
            return;
          }
          if (that.editTitle == '复制消息模板') {
            that.formData['guid'] = '';
            that.postData(addUrl, that.formData)
            return;
          }
          that.$refs['formData'].resetFields();
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    /**
     * 提交表单数据方法
     * @param {*} url 
     * @param {*} data 
     * @param {*} msg 
     */
    postData(url, data, msg = '') {
      let that = this;
      that.api.postJson(`/${serverConfig.msConfigureService}` + url, data).then((res) => {
        if (res.data.code == '00000') {
          that.dialogEdit = false;
          that.$message.success(msg ? msg : '提交成功');
          that.getData(true);
          // that.$refs['formData'].resetFields();
        } else {
          console.log(data)
          that.formData.messageType = data.messageType.split(',');

          if (that.formData.appSideGuids) {
            let appData = JSON.parse(data.appSideGuids);
            that.formData.appSideGuids = appData.map(item => item = item.appSideGuid);
          }

          if (that.formData.roleGuids) {
            let roleData = JSON.parse(data.roleGuids);
            that.formData.roleGuids = roleData.map(item => item = item.guid);
          }

          that.$message.error(res.data.msg);
        }
      }).catch(error => {
        that.formData.messageType = that.formData.messageType.split(',');

        if (that.formData.roleGuids) {
          that.formData.roleGuids = that.formData.roleGuids.map(item => item = item.guid);
        }

        if (that.formData.appSideGuids) {
          that.formData.appSideGuids = that.formData.appSideGuids.map(item => item = item.appSideGuid);
        }
      });
    },
    /**
     * 清空搜索
     */
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        templateName: '', // 模板名称 
        appSideGuids: '', // 应用端
      };
      self.getData(true);
    },
    /**
     * 获取列表信息
     * @param {*} flg 
     */
    getData(flg) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.api.postCan('/ms-configure-service/message/template/get-message-template-list', self.page).then((res) => {
        if (res.data.code == '00000') {
          self.loading = false;
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 上传图标
     * @param {*} file 
     */
    uploadImage(file) {
      let self = this;
      console.log(file.file);
      self.fileList = [];
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.url, formData)
        .then((res) => {
          if (res.data.code == '00000') {
            self.formData.iconUrl = res.data.data;
            let item = {
              name: 'icon',
              url: res.data.data,
            };
            self.fileList.push(item);
            self.formData.iconUrl = res.data.data;
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    /**
     * 移除文件
     * @param {*} file 
     */
    handleRemove(file) {
      let self = this;
      self.formData.iconUrl = '';
      self.iconSh = false;
      self.fileList = [];
    },
    /**
     * 预览文件
     * @param {*} file 
     */
    handlePictureCardPreview(file) {
      this.dialogImageUrl1 = file.url;
      this.dialogVisible = true;
    },
    /**
     * 下载文件
     * @param {*} file 
     */
    handleDownload(file) {
      console.log(file);
    },
    /**
     * 调整每页数量
     * @param {*} val 
     */
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    /**
     * 分页
     * @param {*} val 
     */
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val || 1;
      this.getData();
    },
    
  },
};
</script>

<style scoped>
.timeRadio{
  display: flex;
}

/* 搜索区输入/下拉宽度（运营端公共样式未提供该类） */
.w65f {
  width: 65%;
}

.classification-box {
  width: 100%;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}

.classification-box .c1 {
  width: calc(100% - 150px - 100px - 56px);
}

.classification-box .c2 {
  width: 150px;
  margin-left: 4px;
}

.classification-box .c3 {
  width: 100px;
  margin: 0px 4px;
}
.border1px{
  margin-left: 150px;
  text-align: start;
  color:#4fa1a4 ;
}
</style>
<style>
.timeRadio .el-form-item__content{
  margin-left: 0!important
}

</style>
